import { withField, withRow } from 'components/InputsUtils';
import { WrappedInputProps } from 'components/InputsUtils/types';
import Input from './Input';

export default withRow(withField<WrappedInputProps>(Input));
